const cities = [
    {
        id: "artigas",
        name: "Artigas",
    },
    {
        id: "canelones",
        name: "Canelones",
    },
    {
        id: "cerrolargo",
        name: "Cerro Largo",
    },
    {
        id: "colonia",
        name: "Colonia",
    },
    {
        id: "durazno",
        name: "Durazno",
    },
    {
        id: "flores",
        name: "Flores",
    },
    {
        id: "florida",
        name: "Florida",
    },
    {
        id: "lavalleja",
        name: "Lavalleja",
    },
    {
        id: "maldonado",
        name: "Maldonado",
    },
    {
        id: "montevideo",
        name: "Montevideo",
    },
    {
        id: "paysandu",
        name: "Paysandú",
    },
    {
        id: "rionegro",
        name: "Río Negro",
    },
    {
        id: "rivera",
        name: "River",
    },
    {
        id: "rocha",
        name: "Rocha",
    },
    {
        id: "salto",
        name: "Salto",
    },
    {
        id: "sanjose",
        name: "San José",
    },
    {
        id: "soriano",
        name: "Soriano",
    },
    {
        id: "tacuarembo",
        name: "Tacuarembó",
    },
    {
        id: "treintaytres",
        name: "Treinta y Tres",
    },
];

const statesUSA = [
    {
        id: "alabama",
        name: "Alabama",
    },
    {
        id: "alaska",
        name: "Alaska",
    },
    {
        id: "arizona",
        name: "Arizona",
    },
    {
        id: "arkansas",
        name: "Arkansas",
    },
    {
        id: "california",
        name: "California",
    },
    {
        id: "colorado",
        name: "Colorado",
    },
    {
        id: "connecticut",
        name: "Connecticut",
    },
    {
        id: "delaware",
        name: "Delaware",
    },
    {
        id: "florida",
        name: "Florida",
    },
    {
        id: "georgia",
        name: "Georgia",
    },
    {
        id: "hawaii",
        name: "Hawaii",
    },
    {
        id: "idaho",
        name: "Idaho",
    },
    {
        id: "illinois",
        name: "Illinois",
    },
    {
        id: "indiana",
        name: "Indiana",
    },
    {
        id: "iowa",
        name: "Iowa",
    },
    {
        id: "kansas",
        name: "Kansas",
    },
    {
        id: "kentucky",
        name: "Kentucky",
    },
    {
        id: "louisiana",
        name: "Louisiana",
    },
    {
        id: "maine",
        name: "Maine",
    },
    {
        id: "maryland",
        name: "Maryland",
    },
    {
        id: "massachusetts",
        name: "Massachusetts",
    },
    {
        id: "michigan",
        name: "Michigan",
    },
    {
        id: "minnesota",
        name: "Minnesota",
    },
    {
        id: "mississippi",
        name: "Mississippi",
    },
    {
        id: "missouri",
        name: "Missouri",
    },
    {
        id: "montana",
        name: "Montana",
    },
    {
        id: "nebraska",
        name: "Nebraska",
    },
    {
        id: "nevada",
        name: "Nevada",
    },
    {
        id: "newhampshire",
        name: "New Hampshire",
    },
    {
        id: "newjersey",
        name: "New Jersey",
    },
    {
        id: "newmexico",
        name: "New Mexico",
    },
    {
        id: "newyork",
        name: "New York",
    },
    {
        id: "northcarolina",
        name: "North Carolina",
    },
    {
        id: "northdakota",
        name: "North Dakota",
    },
    {
        id: "ohio",
        name: "Ohio",
    },
    {
        id: "oklahoma",
        name: "Oklahoma",
    },
    {
        id: "oregon",
        name: "Oregon",
    },
    {
        id: "pennsylvania",
        name: "Pennsylvania",
    },
    {
        id: "rhodeisland",
        name: "Rhode Island",
    },
    {
        id: "southcarolina",
        name: "South Carolina",
    },
    {
        id: "southdakota",
        name: "South Dakota",
    },
    {
        id: "tennessee",
        name: "Tennessee",
    },
    {
        id: "texas",
        name: "Texas",
    },
    {
        id: "utah",
        name: "Utah",
    },
    {
        id: "vermont",
        name: "Vermont",
    },
    {
        id: "virginia",
        name: "Virginia",
    },
    {
        id: "washington",
        name: "Washington",
    },
    {
        id: "westvirginia",
        name: "West Virginia",
    },
    {
        id: "wisconsin",
        name: "Wisconsin",
    },
    {
        id: "wyoming",
        name: "Wyoming",
    },
];

const europeanCountries = [
    {
        id: "germany",
        name: "Germany",
    },
    {
        id: "france",
        name: "France",
    },
    {
        id: "spain",
        name: "Spain",
    },
    {
        id: "italy",
        name: "Italy",
    },
    {
        id: "united_kingdom",
        name: "United Kingdom",
    },
    {
        id: "netherlands",
        name: "Netherlands",
    },
    {
        id: "belgium",
        name: "Belgium",
    },
    {
        id: "portugal",
        name: "Portugal",
    },
    {
        id: "sweden",
        name: "Sweden",
    },
    {
        id: "norway",
        name: "Norway",
    },
    {
        id: "finland",
        name: "Finland",
    },
    {
        id: "denmark",
        name: "Denmark",
    },
    {
        id: "switzerland",
        name: "Switzerland",
    },
    {
        id: "austria",
        name: "Austria",
    },
    {
        id: "poland",
        name: "Poland",
    },
    {
        id: "czech_republic",
        name: "Czech Republic",
    },
    {
        id: "hungary",
        name: "Hungary",
    },
    {
        id: "ireland",
        name: "Ireland",
    },
    {
        id: "greece",
        name: "Greece",
    },
    {
        id: "iceland",
        name: "Iceland",
    },
];


export { cities, statesUSA, europeanCountries}